import React from 'react';

// DO NOT EDIT - THIS FILE IS GENERATED
/* eslint-disable */

var emailUs24Icon = /*#__PURE__*/React.createElement("svg", {
  height: "24",
  width: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  d: "M23.72 4.87a.73.73 0 0 0-.72-.62H1a.73.73 0 0 0-.72.62V18A3.75 3.75 0 0 0 4 21.75h16A3.75 3.75 0 0 0 23.75 18V4.87Zm-1.5.88a2.29 2.29 0 0 1-.87 1.43l-9.35 7-9.35-7a2.29 2.29 0 0 1-.87-1.43ZM20 20.25H4A2.25 2.25 0 0 1 1.75 18V8.38l9.8 7.35a.75.75 0 0 0 .9 0l9.8-7.35V18A2.25 2.25 0 0 1 20 20.25ZM6.82 14.82a1 1 0 0 1 0 1.42l-2.29 2.29-.35-.35a1 1 0 0 1 0-1.42l2.29-2.29Zm13 1.94a1 1 0 0 1 0 1.42l-.35.35-2.29-2.29a1 1 0 0 1 0-1.42l.35-.35Z",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
}));

export { emailUs24Icon as default };
//# sourceMappingURL=emailUs24Icon.js.map
